module.exports = __webpack_public_path__ + "bb4d3125b65bdacbcc574e5ca562392a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 1988
// module chunks = 0